import Token from 'markdown-it/lib/token';
export default function (md, idMap, featureToggles, htmlConversionCounts) {
  const rule = md.inline.ruler.before('text', 'custom', function (state, silent) {
    var _match$groups, _match$groups2, _match$groups3;
    const start = state.pos;
    const origSrc = state.src;
    const match = state.src.slice(start).match(
    /**
     * Matches the following:
     * <custom data-type="smartlink" data-id="123">content</custom>
     * <custom data-id="123">content</custom>
     * <custom data-type="emoji">content</custom>
     * <custom>content</custom>
     */
    /<custom(\sdata-(type|id)="(?<dataType>.*?)")?(\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\/custom>/);
    if (!match) {
      return false;
    }
    const tagLength = match[0].length;
    const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
    const dataType = (_match$groups = match.groups) === null || _match$groups === void 0 ? void 0 : _match$groups.dataType;
    const dataId = (_match$groups2 = match.groups) === null || _match$groups2 === void 0 ? void 0 : _match$groups2.dataId;
    const dataContent = (_match$groups3 = match.groups) === null || _match$groups3 === void 0 ? void 0 : _match$groups3.dataContent;
    const afterTag = state.src.slice(start + beforeTag.length + tagLength);
    function mapCustomDataTypeToNodeType(customDataType) {
      switch (customDataType) {
        case 'smartlink':
          return 'inlineCard';
        case 'date':
        case 'emoji':
        case 'status':
        case 'mention':
          return customDataType;
        // Just move below case alongside mention above to remove markdownPlusExtensions FF.
        case 'inlineExtension':
          return featureToggles.markdownPlusV2 && featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
        case 'mediaInline':
          return featureToggles.markdownPlusMedia ? 'mediaInline' : false;
        default:
          // TODO track invalid cards
          return false;
      }
    }
    const customDataType = mapCustomDataTypeToNodeType(dataType);
    if (!silent) {
      var _idMap$dataId, _idMap$dataId2, _idMap$dataId2$marks;
      // tokenize beforeTag
      if (beforeTag) {
        state.src = beforeTag;
        // @ts-ignore
        state.md.inline.tokenize(state, beforeTag);
      }
      if (dataId && idMap !== null && idMap !== void 0 && (_idMap$dataId = idMap[dataId]) !== null && _idMap$dataId !== void 0 && _idMap$dataId.attributes && customDataType) {
        htmlConversionCounts.htmlConvertedToNodes++;
        const customDataToken = state.push(customDataType, '', 0);
        // @ts-ignore
        customDataToken.pmAttrs = idMap[dataId].attributes;

        // Handle marks for text nodes
      } else if (featureToggles.markdownPlusMarks && dataId && idMap !== null && idMap !== void 0 && (_idMap$dataId2 = idMap[dataId]) !== null && _idMap$dataId2 !== void 0 && (_idMap$dataId2$marks = _idMap$dataId2.marks) !== null && _idMap$dataId2$marks !== void 0 && _idMap$dataId2$marks.length && dataType === 'text') {
        const {
          marks
        } = idMap === null || idMap === void 0 ? void 0 : idMap[dataId];
        const openingTokens = [];
        const closingTokens = [];
        marks.forEach(mark => {
          const markName = mark.type.name || mark.type;
          const openingToken = new Token(`${markName}_open`, '', 1);
          const closingToken = new Token(`${markName}_close`, '', -1);

          // @ts-ignore
          openingToken.pmAttrs = mark.attrs;
          openingTokens.push(openingToken);
          closingTokens.unshift(closingToken);
        });
        let textToken = new Token('text', '', 0);
        if (match && (match[0] || dataContent)) {
          textToken.content = dataContent || match[0];
        }
        state.tokens.push(...openingTokens, textToken, ...closingTokens);
      } else {
        htmlConversionCounts.htmlConvertedToFallbackNodes++;
        const textToken = state.push('text', '', 0);

        // If there is no data content we want to hide the custom tags as the AI has hallucinated something
        if (!dataContent) {
          textToken.content = '';
        } else {
          textToken.content = dataContent || match[0];
        }
      }
      if (afterTag) {
        state.src = afterTag;
        state.pos = 0;
        // @ts-ignore
        state.md.inline.tokenize(state, afterTag);
      }
    }
    state.src = origSrc;
    state.pos = start + state.src.length;
    return true;
  });
  return rule;
}